<template>
  <div class="mb-4">
    <div class="font-weight-bold grey--text text--darken-1">{{ rotulo }}</div>
    <slot>
      <div class="text-body-1">{{ valor || "Não informado" }}</div>
    </slot>
  </div>
</template>

<script>
export default {
  name: "EDadoDoAluno",
  props: {
    rotulo: { type: String, required: true },
    valor: { type: [String, Number], default: null },
  },
};
</script>
